import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import TimedDisplay from '../components/TimedDisplay';
import Popup from 'reactjs-popup';
import { Form,Button,Table,Col,Alert } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/Attestation.css';
import { Loading } from '../components/Loading';

export default function AdminPolicies(props) {
    const {
        register,
        handleSubmit,
        reset,
        /*control,*/
        formState: { errors }
    } = useForm();
    const [pending, setPending] = useState(true);
    const [policyVersions, setPolicyVersions] = useState([]);
    const [policyNotes, setPolicyNotes] = useState('');
    const [showConfirm, setShowConfirm] = useState(false);
    const [addMsgLevel,setAddMsgLevel] = useState('');
    const [addMsg, setAddMsg] = useState('');
    const [isAdding, setIsAdding] = useState(false);
    const [isAddComplete, setIsAddComplete] = useState(false);
    
    useEffect(() => {
        console.log(`In Admin Policy `);
        getPolicyVersions();
        //Check if page access is still allowed

        props.onChildUpdate();
    },[]);

    const getPolicyVersions = () => {
        ServiceCalls.getPolicyVersions(5).then(function (data) {
            console.log(`Call to get Admin Policy returned ${data.length}`);
            setPolicyVersions(data);
            setPending(false);
        });
    }

    const onSubmit = (data) => {
        if (data.notes) {
            console.log("Admin data: " + data.notes);
            setPolicyNotes(data.notes);
            setShowConfirm(true);
        }
        else {
            console.log(`No notes passed in for policy`);
        }  
    }

    //const onClearForm = () => {
    //    document.getElementById().reset();
    //    reset({ "notes": null });
    //    setPolicyNotes({});
    //}

    const showAlertMessage =() => {
        if (isAddComplete) {
            return (<TimedDisplay delay="3000" callback={closeModal}>
                <div style={{width:"100%"}}><Alert variant={addMsgLevel}>{addMsg}</Alert></div>
            </TimedDisplay>);
            
        }
        else {
            return (<></>);
        }
    }   
    const renderTable = () => {
        var tblContent = (policyVersions.length > 0) ?
            policyVersions.map(function (item, idx) {
                return (<tr key={idx}>
                    <td>{item.policyVersionId}</td>
                    <td>{item.createDt}</td>
                    <td>{item.notes}</td>
                    <td>{(item.enabled === true) ? "Enabled" : "Disabled"}</td>
                </tr>)
            })
            : <tr><td colSpan={4}>No Current Policy version</td></tr>;

        return (     
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Create Date</th>
                            <th>Notes</th>
                            <th>Enabled</th>
                        </tr>
                    </thead>
                    <tbody>
                    {tblContent}                        
                    </tbody>
                </Table>
               );
    }

    const confirmCreate = () => {
        if (policyNotes) {
            setIsAdding(true);
            ServiceCalls.addPolicyVersion(policyNotes).then(function (newVersion) {
                console.log(`Created a new Terms of Service.  Version ${newVersion.policyVersionId}`);
                var audit = {
                    severity: 'Informational',
                    message: `New Terms of Service version ID: ${newVersion.policyVersionId} created`
                };
                ServiceCalls.postAuditLog(audit).then(function (result) {
                   
                    var msgLvl = (result) ? "success" : "warning";
                    var msgText = (result) ? `Successfully added Terms of Service version ${newVersion.policyVersionId}` : "Failed to create new Terms of Service version. Check logs";
                    setAddMsgLevel(msgLvl);
                    setAddMsg(msgText);
                    setIsAdding(false);
                    setIsAddComplete(true);
                    getPolicyVersions();
                });
            });
        }
        else {
            console.log('Terms of Service Notes are empty');
        }

    }
    const closeModal = () => {
        document.getElementById('adminPolicy').reset();
        reset({ "notes": null });
        setPolicyNotes('');
        setShowConfirm(false);

    }
    const renderModalBtns = () => {
        if (isAdding) {
            return (<Loading />);
        }
        else if (isAddComplete) {
            return (<></>);
        }
        else {
            return (
                <div id="attestBtns">
                    <Button style={{ float: "right", marginLeft: "10px" }} className="OHCID-details-popup-buttons" onClick={() => { confirmCreate(); }}>
                        Confirm
                    </Button>
                    <Button style={{ float: "right", marginRight: "10px" }} className="OHCID-details-popup-buttons" onClick={() => { closeModal(); }}>
                        Close
                    </Button>
                </div>
            );
        }        
    }

    return (
        (pending) ?
            <div style={{ marginTop: "10px", margin: "auto", width: "100px" }}>
                <Loading />
            </div>
        : <div id="policyArea">
            <div id="currentPolicy" className="flex-column borderCurve policyContainer">
                    <h3>Terms of Service Versions</h3>
                { renderTable()}
               
            </div>
            <div id="addPolicyArea" className="flex-column borderCurve policyContainer">
                    <h3>Add Terms of Service Version</h3>
                <Form encType="multipart/form-data" name="adminPolicyAdd" id="adminPolicy"
            onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label></Form.Label>
                        <Form.Control type="text" {...register("notes", {
                            required: 'This field is required',
                            maxLength: { value: 200, message: 'Max character length is 200' },
                            pattern: {
                                value: /^[a-z0-9\s'!.(?),;]+$/i, message: 'Only Alphanumeric characters are allowed' }
                        })}
                                placeholder="Enter notes about this Terms of Service" />
                            
                        <Form.Text className="text-muted">{errors.notes && <p role="alert" className="error">{errors.notes?.message}</p>}</Form.Text>
                    </Form.Group>
                    <Col className="mb-9">
                        <Button variant="primary" className="right" type="submit">Create</Button>
                    </Col>
                </Form>
            </div>
            <Popup open={showConfirm} modal closeOnDocumentClick={false}>
                <div id="adminConfirmPolicy">
                    <h4 id="adminConfirmHdr">Confirm Version Creation</h4>
                    <div id="adminConfirmPolicyText">
                            By creating a new Terms of Service version, all users of the application will be prompted with the attestation next time they access the site.
                        Are you sure you want to do this?
                    </div>

                        <div>
                            {renderModalBtns()}
                            {showAlertMessage()}
                        </div>
              
                </div>
            </Popup>  
        </div>
    );
}